import api from "./api";
import { APIS } from "../endpoints";


export const getAllProjectsData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.projects}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getProjectData = async (alias) => {
    // Construct the endpoint URL conditionally based on the presence of `section`
    const endpoint = `${APIS.BASE_URL}${APIS.projects}/${alias}`;

    try {
        const result = await api.get(endpoint);

        // Return the `data` if the result exists, otherwise return an empty array
        return result?.data?.data || [];
    } catch (error) {
        console.error('Error fetching projects data:', error);
        return [];
    }
};

export const updateProjectData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.projects}/${alias}`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const createNewProject = async (data) => {

    const result = await api.post(`${APIS.BASE_URL}${APIS.projects}`, data)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
}